import * as Sentry from '@sentry/react';
import { GlobalStyles } from 'GlobalStyles';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import App from 'App';
import { store } from 'app/store';
import 'global.css';
import Notification from 'modules/alert';
import theme from 'theme';
import { ENV, PRODUCTION } from './constants/env';

if (ENV.NODE_ENV === PRODUCTION) {
  const DSN = ENV.VITE_SENTRY_DSN;
  const environment = ENV.VITE_ENVIRONMENT || PRODUCTION;
  Sentry.init({
    dsn: DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    environment,
    tracesSampleRate: 1.0,
  });
}

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <App />
      <Notification />
    </ThemeProvider>
  </Provider>
);
